import { render } from "./SmartCardNotifcationSetting.vue?vue&type=template&id=10f3b448&scoped=true"
import script from "./SmartCardNotifcationSetting.vue?vue&type=script&lang=js"
export * from "./SmartCardNotifcationSetting.vue?vue&type=script&lang=js"

import "./SmartCardNotifcationSetting.vue?vue&type=style&index=0&id=10f3b448&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10f3b448"

export default script